(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.collections-carousel__track');
    if (!carousel) return;

    const prevBtn = document.querySelector('.carousel-nav--prev');
    const nextBtn = document.querySelector('.carousel-nav--next');
    const cards = carousel.querySelectorAll('.collection-card');
    
    if (cards.length === 0) return;

    let currentIndex = 0;
    const cardWidth = cards[0].offsetWidth + 24; // card width + gap
    const visibleCards = Math.floor(carousel.parentElement.offsetWidth / cardWidth);
    const maxIndex = Math.max(0, cards.length - visibleCards);

    function updateCarousel() {
      const offset = currentIndex * cardWidth;
      carousel.style.transform = `translateX(-${offset}px)`;
      
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }

    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    });

    nextBtn.addEventListener('click', () => {
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    });

    updateCarousel();

    // Update on resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        currentIndex = 0;
        updateCarousel();
      }, 250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrival-popup"]) return;
  try {
    
  (function() {
    const overlay = document.getElementById('NewArrivalPopup');
    if (!overlay) return;

    const closeBtn = document.getElementById('NewArrivalPopupClose');
    const ctaBtn = overlay.querySelector('.new-arrival-popup__cta');
    const sessionHideKey = 'new_arrival_popup_cta_clicked';

    async function syncPreorderLabel() {
      if (!ctaBtn) return;

      const preorderLabel = ctaBtn.dataset.preorderLabel;
      const buyLabel = ctaBtn.dataset.buyLabel;

      if (!preorderLabel || !buyLabel) return;

      const href = ctaBtn.getAttribute('href') || '';
      if (!href || href.indexOf('/products/') === -1) return;

      try {
        const url = new URL(href, window.location.origin);
        const parts = url.pathname.split('/products/');
        if (parts.length < 2) return;

        const handle = (parts[1] || '').split('/')[0];
        if (!handle) return;

        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        const candidateUrls = [];
        candidateUrls.push(rootUrl + 'products/' + handle + '.js');
        if (rootUrl !== '/') {
          candidateUrls.push('/products/' + handle + '.js');
        }

        let productData = null;
        for (const candidateUrl of candidateUrls) {
          const response = await fetch(candidateUrl, { credentials: 'same-origin' });
          if (!response.ok) {
            continue;
          }

          productData = await response.json();
          if (productData) {
            break;
          }
        }

        if (!productData) return;

        let tags = '';
        if (Array.isArray(productData.tags)) {
          tags = productData.tags.join(',').toLowerCase();
        } else {
          tags = (productData.tags || '').toString().toLowerCase();
        }
        const isPreorder = tags.indexOf('precommande') !== -1 || tags.indexOf('précommande') !== -1;

        ctaBtn.textContent = isPreorder ? preorderLabel : buyLabel;
      } catch (error) {
      }
    }

    function show() {
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
    }

    function hide() {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
      try { sessionStorage.setItem(sessionHideKey, '1'); } catch (e) {}
    }

    if (closeBtn) closeBtn.addEventListener('click', hide);

    if (ctaBtn) {
      ctaBtn.addEventListener('click', hide);
    }

    overlay.addEventListener('click', function(event) {
      if (event.target === overlay) hide();
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && overlay.classList.contains('is-visible')) {
        hide();
      }
    });

    if (window.Shopify && window.Shopify.designMode) {
      syncPreorderLabel();
      show();
      return;
    }

    let hiddenForSession = false;
    try { hiddenForSession = sessionStorage.getItem(sessionHideKey) === '1'; } catch (e) {}
    if (hiddenForSession) return;

    syncPreorderLabel();
    show();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rentree-popup"]) return;
  try {
    
  (function () {
    const overlay = document.getElementById('RentreePopup');
    if (!overlay) return;

    const modal = overlay.querySelector('.rentree-popup');
    const closeBtn = document.getElementById('RentreePopupClose');
    const cta = document.getElementById('RentreePopupCta');
    const STORAGE_KEY = 'rentree_popup_seen';
    // parseInt then guard on NaN, not falsiness: `|| 6` turned a configured 0
    // back into 6 seconds, so "instant" was impossible to set.
    const rawDelay = parseInt(overlay.dataset.delay, 10);
    const delayMs = (isNaN(rawDelay) ? 0 : rawDelay) * 1000;

    // Re-attempt as soon as the newsletter popup goes away, rather than polling.
    function retryOnClose() {
      if (document.querySelector('.newsletter-popup__overlay.is-visible')) return;
      document.removeEventListener('keydown', retryOnClose);
      document.removeEventListener('click', retryOnClose, true);
      show();
    }

    function show() {
      // Only defer if the newsletter popup is ALREADY on screen — never poll,
      // which is what added seconds on top of the configured delay.
      if (document.querySelector('.newsletter-popup__overlay.is-visible')) {
        document.addEventListener('keydown', retryOnClose);
        document.addEventListener('click', retryOnClose, true);
        return;
      }

      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      if (closeBtn) closeBtn.focus();
    }

    function hide(persist) {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      // Once per session: dismissing marks it seen until the tab is closed.
      if (persist) {
        try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      }
    }

    function alreadySeen() {
      try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () { hide(true); });
    }

    // Clicking through counts as handled.
    if (cta) {
      cta.addEventListener('click', function () { hide(true); });
    }

    // Click the dimmed area, but not the card itself.
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) hide(true);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('is-visible')) {
        hide(true);
      }
    });

    // Keep tab focus inside the dialog while it is open.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !overlay.classList.contains('is-visible') || !modal) return;

      const focusable = modal.querySelectorAll('a[href], button:not([disabled])');
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    // Theme editor: always show immediately so it can be styled.
    if (window.Shopify && window.Shopify.designMode) {
      show();
      return;
    }

    if (alreadySeen()) return;

    if (delayMs <= 0) {
      show();
    } else {
      setTimeout(show, delayMs);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
